/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const SPACING = 12; // @TODO: abstract with SideDrawer

const getStyles = ({globalScale, colors}) => {
  return {
    recentGoals: { // @TODO: make more general and share (make part of listitem and toggle background color and border with prop)
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: `${colors.primaryDark}44`, // @TODO: abstract with friends widget
      borderRadius: 8,
      padding: 4,
      marginTop: 4, // @TODO: update this
    },
    actionIcon: { // @TODO: would like to reuse this (in WidgetBase/Header/styles.native.js)
      fontSize: globalScale * 16,
    },
    option: { // @TODO: abstract this and all styles below with SideDrawer
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingLeft: globalScale * 0, // @TODO: this is 10 in SideDrawer, but we don't want indentation here
      paddingTop: globalScale * 4,
      paddingBottom: globalScale * 4,
    },
    optionTextWrapper: {
      flex: 1,
    },
    optionText: {
      // @TODO: width: '100%', // otherwise, android truncates some of the options (like the "t" in "About")
      // @TODO: color: isDarkMode ? colors.white : colors.black,
      flex: 1,
      color: colors.white,
      fontSize: globalScale * 16,
      marginLeft: globalScale * SPACING,
      marginRight: globalScale * SPACING / 2,
      maxHeight: globalScale * 30, // @TODO: globalscale?
    },
  };
};

export default getStyles;
